import { apiGet } from '../services/apiClient';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') qs.set(key, value);
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

export const listPayments = (token, params = {}) => apiGet(`/api/admin/finance/payments${buildQuery(params)}`, token);
export const getPayment = (token, id) => apiGet(`/api/admin/finance/payments/${id}`, token);
